<div class="view-order">
    <div class="header-wrapper d-flex justify-content-between align-item">
        <span class="info-text nunito font-18 fw-600">{{'AssignOrder'|translate}}</span>
        <i class="material-icons cursor-pointer" (click)="dialogClose('close')">clear</i>
    </div>

  
        <div class="order-request nunito d-flex  flex-column">
            <strong class="request-heading font-14 d-block">{{'AvailableChef'|translate}}</strong>
            <div class="assign-chef-dropdown">
                <mat-form-field class="example-chip-list manage-order-selection" floatLabel="never">
                    <mat-chip-list #chipList aria-label="Staff selection">
                        <mat-chip *ngFor="let staff of selectedStaff" [selectable]="selectable" [removable]="removable"
                        (removed)="remove(staff)">
                        {{staff.staffName}}
                            <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
                        </mat-chip>
                        <input placeholder="Select" #staffInput [formControl]="StaffCtrl" [matAutocomplete]="auto"
                            [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                            (matChipInputTokenEnd)="add($event)"  (input)="filterStaff(staffInput.value)"
                            (click)="filterStaff(staffInput.value)">
                    </mat-chip-list>
                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)"
                        class="dropdown-wrapper-payment custom-scrollbar">
                        <div class="dropdown-list-wrapper">
                            <div class="dropdown-list relative custom-scrollbar">
                                <mat-option *ngFor="let staffMember of filteredStaff | async " [value]="staffMember">
                                    {{staffMember.StaffName}}
                                </mat-option>
                            </div>
                            <button class="absolute assignee-button d-flex align-items-center font-16 nunito" (click)="assignSelf()">
                                <svg class="asign-btn-icon" width="20" height="20" viewBox="0 0 20 20" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9 15H11V11H15V9H11V5H9V9H5V11H9V15ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6873 3.825 17.975 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.262667 12.6833 0 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31267 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.31233 6.1 0.787C7.31667 0.262333 8.61667 0 10 0C11.3833 0 12.6833 0.262333 13.9 0.787C15.1167 1.31233 16.175 2.025 17.075 2.925C17.975 3.825 18.6873 4.88333 19.212 6.1C19.7373 7.31667 20 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6873 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6873 13.9 19.212C12.6833 19.7373 11.3833 20 10 20ZM10 18C12.2333 18 14.125 17.225 15.675 15.675C17.225 14.125 18 12.2333 18 10C18 7.76667 17.225 5.875 15.675 4.325C14.125 2.775 12.2333 2 10 2C7.76667 2 5.875 2.775 4.325 4.325C2.775 5.875 2 7.76667 2 10C2 12.2333 2.775 14.125 4.325 15.675C5.875 17.225 7.76667 18 10 18Z" fill="#001847" />
                                </svg>
                                Assign Self</button>
                        </div>
                    </mat-autocomplete>
                </mat-form-field>
            </div>
        </div>

        <div class="assign-chef-btn-grp">
            <button class="chef-btn reset-chef nunito" (click)="clearSelectedStaff()">Reset</button>
            <button class="chef-btn apply-chef nunito" (click)="ApplycloseDialog()">Apply</button>
        </div>
   

</div>